module.exports = __webpack_public_path__ + "static/media/logoastro.b1937cf6.png";